<mat-expansion-panel
    class="w-full"
    [expanded]="true">
    <mat-expansion-panel-header class="!font-semibold !text-base pb-2 !pl-2"
        >{{ 'status' | transloco: { COUNT: sortStatusByCheck.length } }}
    </mat-expansion-panel-header>
    @for (status of sortStatusByCheck(); track status) {
        <div
            class="pl-0 mb-2 flex items-center cursor-pointer"
            [class.option-selected]="filterEntitiesTableService.filterByParams()?.statuses?.includes(status)"
            (click)="filterEntitiesTableService.toggleStatusSelection(status)">
            <app-checkbox
                [checkboxState]="
                    filterEntitiesTableService.filterByParams()?.statuses?.includes(status)
                        ? CheckboxState.CHECKED
                        : CheckboxState.UNCHECKED
                "
                [disabled]="!filterEntitiesTableService.statuses().includes(status)" />

            <div class="flex flex-row justify-center items-center">
                <app-field-intervention-status
                    class="mx-1"
                    [disabled]="!filterEntitiesTableService.statuses().includes(status)"
                    [hasTooltip]="false"
                    [size]="1.5"
                    [status]="status" />
            </div>
        </div>
    }
</mat-expansion-panel>
